/**
 * QUIZ · BẢN SỬA GIAI ĐOẠN 1 (tài liệu marketing 07/09/2026).
 *
 * VÌ SAO LÀ FILE RIÊNG. `assets/quiz-inner-weather.js` (28.983 dòng) được bê NGUYÊN từ
 * minespirit-quiz và đã bị THAY TRỌN GÓI một lần (commit 63a7ff1 · 03/09). Vá nằm trong
 * nó là mất sạch, im lặng. Mọi thứ dưới đây đè từ ngoài, đúng lối `quiz-sang-trang-ban.js`
 * và `quiz-do-duong.js` đã đi.
 *
 * THỨ TỰ THẺ <script> QUAN TRỌNG — file này là SỐ 5 (xem sections/quiz-inner-weather.liquid):
 *   1 quiz-inner-weather.js · 2 quiz-anh-hop.js · 3 quiz-chuyen-man-muot.js
 *   4 quiz-sang-trang-ban.js · 5 FILE NÀY · 6 quiz-goi-api.js · 7 quiz-do-duong.js
 * Hai ràng buộc CỨNG, đổi chỗ là hỏng CÂM:
 *   trước #6 — `quiz-goi-api.js` BỌC `RENDER.hub` để gọi `gui()` (xin mã phiên). File này
 *     THAY HẲN `RENDER.hub`; chạy sau #6 là ném mất bọc đó, không có `session_id`, đơn về
 *     rỗng thuộc tính — đúng triệu chứng đơn #1016/#1017.
 *   trước #7 — file này dựng lại `SCREENS` rồi vẽ lại màn đang hiện. `quiz-do-duong.js`
 *     chốt `screens_hash` và bắn `screen_viewed` đầu tiên NGAY LÚC NÓ CHẠY; chạy sau nó thì
 *     dấu vân tay và event đầu đều là của mảng CŨ.
 * Hệ quả đã tính: lúc file này chạy thì kênh gửi event (`window.__msSuKien`, do #7 phơi ra)
 * CHƯA có, nên event được đệm lại và xả ở `DOMContentLoaded` — mọi thẻ đều `defer` nên lúc
 * đó #7 đã chạy xong.
 *
 * BUNDLE LÀ MỘT CHỒNG LỚP ĐÈ. `RENDER.intro` khai 5 lần, `SCREENS` dựng 4 lần, lớp cuối
 * thắng. Đè sai lớp là rơi vào khoảng không, KHÔNG lỗi nào báo. Các mốc cuối đã dò lại
 * ngày 08/09/2026 trên chính file trong repo này:
 *   SCREENS dựng lần cuối ở `v10Screens` (:23787), rồi `v12gGender` (:28414) chèn màn
 *     xưng hô — nên đây là lớp SAU CÙNG, chạy được.
 *   RENDER.intro cuối ở `v10Intro` (:23808) · RENDER.bdate cuối ở :21424
 *   RENDER.name cuối ở :10964 · RENDER.email cuối ở :9480 · RENDER.hub cuối ở :10233
 *   QUIZ7.score cuối ở :23713 (đọc `QUIZ7.ranked` LÚC CHẠY → sửa mảng đó là đủ)
 */
(function () {
  'use strict';

  if (typeof SCREENS === 'undefined' || typeof RENDER !== 'object' || typeof QUIZ7 === 'undefined') return;

  /* ══════════════════════════════════════════════════════════════════════════
     0 · TIỆN ÍCH
     ══════════════════════════════════════════════════════════════════════════ */

  /* Chữ song ngữ chép NGUYÊN VĂN từ tài liệu. Không đi qua `T()`/`UI_STRINGS_VI` vì bảng
     đó là của bản cũ — thêm khoá vào đó là sửa chữ ở hai nơi cho một câu. */
  function L(en, vi) { return isVI() ? vi : en; }

  var GD1 = {
    /* mục 1 · Intro — BẢN RÚT GỌN CỦA MÀN 1 v7.9, chỉ chạy khi thiếu snapshot bộ đề.

       Màn 1 mà khách thật nhìn thấy nằm ở `quiz-bo-de-dung-man.js` (`RENDER.intro` của A1,
       phase 19): đủ ảnh đầu trang, thẻ xem trước 7 cột, khối số liệu, khối "dành cho ai" và
       thẻ nhận xét. Năm khoá dưới đây là bốn dòng chữ đầu của chính màn đó, chép nguyên văn
       từ `ref/3-NGUYEN-LIEU/3-chu-tung-man/`, và phải TRÙNG TỪNG CHỮ với màn chào tĩnh trong
       `sections/quiz-inner-weather.liquid`.

       Vì sao phải trùng: màn chào tĩnh là thứ khách đọc trong lúc 2 MB JS còn đang về (đo
       15/09: `#app` trắng 14,7 giây trên 4G chậm). Lệch một chữ là khách đọc một câu rồi thấy
       nó đổi ngay trước mắt. Ba chuỗi của bản 7-DAY RESET ("THE 7-DAY RESET", "7-day plan",
       "first step tonight") đã bỏ khỏi CẢ BA nơi — phase 19 không cho chúng sống ở đâu nữa.

       `introMeta` bỏ hẳn: v7.9 nói thời lượng bằng chip "7-min quiz" trong màn đầy đủ, và
       bản rút gọn không có hàng chip nên cũng không có chỗ cho dòng đó. */
    introKick:  ['7 AREAS · ONE READING', '7 VÙNG · MỘT BẢN ĐỌC'],
    introTitle: ['Understand what is really draining your energy, and get yourself back.',
                 'Hiểu điều gì thật sự đang rút cạn năng lượng của bạn, và tìm lại chính mình.'],
    introSub:   ['Understand yourself better, and know what to expect next.',
                 'Hiểu rõ hơn về bản thân, và biết điều gì đang chờ phía trước.'],
    introBtn:   ['Start the quiz', 'Bắt đầu quiz'],
    introTiny:  ['Free: your type and what drains you most. Full reading optional ($4.90).',
                 'Miễn phí: kiểu người của bạn và điều rút cạn bạn nhất. Bản đọc đầy đủ tuỳ chọn ($4.90).'],

    /* mục 2 · Ngày sinh · Tên · Email */
    bdateTitle: ['When were you born?', 'Bạn sinh ngày nào?'],
    bdateSub:   ['So we can calculate your personal years: what the next 2 to 10 years hold for you.',
                 'Để chúng tôi tính năm cá nhân của bạn: 2 đến 10 năm tới sẽ như thế nào.'],
    bdateGo:    ['Continue', 'Tiếp tục'],
    bdateSkip:  ['Skip', 'Bỏ qua'],

    /* Tiêu đề màn tên dựng thẳng trong `RENDER.name` để giữ thẻ tô vàng của bản gốc; bảng
       này để đối chiếu với tài liệu. KHÔNG đi qua `T()` được: bản dịch VI trong
       `UI_STRINGS_VI` viết cứng "gọi chị", mà mục 4.1 đã bỏ màn xưng hô và chốt mặc định
       "gọi bằng tên" — tức "bạn". Đo 08/09 ở `?lang=vi`: `T()` trả "Chúng tôi nên gọi chị
       là gì?", lệch tài liệu. */
    nameTitle:  ['What should we call you?', 'Chúng tôi nên gọi bạn là gì?'],
    nameField:  ['Your first name', 'Tên của bạn'],
    nameGo:     ['Continue', 'Tiếp tục'],

    emailTitle: ['Your 7 areas are checked, {Name}. Enter your email to see your weakest one.',
                 '7 vùng của bạn đã kiểm xong, {Name}. Nhập email để xem vùng yếu nhất.'],
    emailField: ['Email address', 'Địa chỉ email'],
    emailSub:   ['Private. No spam. Leave any time.', 'Riêng tư. Không spam. Rời bất cứ lúc nào.'],
    emailGo:    ['Show my weakest area', 'Xem vùng yếu nhất của tôi'],

    /* mục 3.2 · Màn kết quả */
    resKick:    ['YOUR 7 AREAS CHECKED', '7 VÙNG CỦA BẠN ĐÃ KIỂM'],
    resBox1:    ['Weakest area', 'Vùng yếu nhất'],
    /* Nhãn riêng cho tim. Ô này in `axes[edge]` — điểm cân bằng của vùng — chứ không
       phải giá trị thắng cuộc đua. Với sáu tầng kia hai số đó là một, nên 'Weakest
       area' đúng. Với tim thì không: cuộc đua chạy trên min(give, receive) còn số
       hiện là mid, nên nhãn cũ khẳng định một điều sai — xem khối `oNhatVung`. */
    resBox1Tim: ["Where it's leaking", 'Chỗ đang rò'],
    resBox2a:   ['Next test', 'Thử thách gần nhất'],
    resBox2b:   ['First step', 'Bước đầu'],
    resTonight: ['tonight', 'tối nay'],
    resLocks:   [['Why this area went first', 'What to do tonight (90 seconds)', 'Your months ahead', 'Your 5-step solution path'],
                 ['Vì sao vùng này yếu trước', 'Làm gì tối nay (90 giây)', 'Những tháng tới', 'Lộ trình 5 bước']],
    resBtn:     ['Get my map & my plan', 'Nhận bản đồ & kế hoạch của tôi'],
    resUnder:   ['Your map, your next months and your solution path, all in one reading',
                 'Bản đồ, những tháng tới và lộ trình giải pháp, trong một bản đọc'],

    /* ── Bản cho nhánh Skip ngày sinh — MÀN KẾT QUẢ ─────────────────────────────
       Lúc đứng ở màn này khách Skip chưa có lá số, nên ba chuỗi dưới đây gỡ mọi lời hứa
       về Bản đồ: không "months ahead", không "map". Chỉ nói về thứ đã tính được ngay:
       7 vùng có điểm, nghi thức 90 giây, lộ trình 5 bước.

       KHỐI GIÁ thì khác (xem `offTitleSkip` và `offMapSau`): từ 08/09/2026 khách Skip
       mua trọn gói và điền ngày sinh sau thanh toán, nên tên gói và dòng lợi ích Bản đồ
       giữ nguyên ở đó, kèm một dòng nói rõ Bản đồ dựng sau.

       Bản KHÔNG Skip ở trên phải giữ NGUYÊN VĂN: tài liệu marketing chốt chép nguyên
       văn và đã được duyệt. Sửa chữ ở đó là đi ra ngoài bản duyệt. */
    resLocksSkip: [['Why this area went first', 'What to do tonight (90 seconds)', 'Your 5-step solution path'],
                   ['Vì sao vùng này yếu trước', 'Làm gì tối nay (90 giây)', 'Lộ trình 5 bước']],
    resBtnSkip:   ['Get my report & my plan', 'Nhận báo cáo & kế hoạch của tôi'],
    resUnderSkip: ['Your 7 areas, your ritual tonight and your solution path, all in one reading',
                   '7 vùng của bạn, nghi thức tối nay và lộ trình giải pháp, trong một bản đọc'],

    /* mục 3.7 · Khối lợi ích + giá */
    offTitle:   ['Your map and your plan are ready, {Name}.', 'Bản đồ và kế hoạch của bạn đã sẵn sàng, {Name}.'],
    offHold:    ['Your price is held for you', 'Giá đang được giữ cho bạn'],
    offPrice:   ['MAP & REPORT · $4.90 · one payment · digital reading · yours to keep',
                 'Bản đồ & Báo cáo · $4.90 · trả một lần · bản đọc số · giữ trọn'],
    /* Nút 36b (khối giá): PDF trang 12 ghi "Get my map & plan", nhưng yêu cầu 09/09/2026
       thêm "my" thứ hai cho khớp nút màn kết quả. Vẫn tách khoá riêng với `resBtn`. */
    offBtn:     ['Get my map & my plan', 'Nhận bản đồ & kế hoạch của tôi'],
    offUnder:   ['28-day money-back. Reply to the email, no form',
                 'Hoàn tiền 28 ngày. Trả lời email, không cần form'],

    /* Tiêu đề khối cho khách Skip: Bản đồ CHƯA sẵn — nó dựng sau khi khách điền ngày sinh
       (xem `offMapSau`). Tên gói và các dòng lợi ích thì KHÔNG có bản Skip: gói vẫn là
       "Map & Report", chỉ giao phần Bản đồ muộn hơn. Trước 08/09/2026 khách Skip từng thấy
       tên gói đổi thành "REPORT & PLAN" và mất bốn dòng Bản đồ, trong khi ngay dưới lại có
       câu hứa Bản đồ sẽ hiện — hai câu trên một màn nói ngược nhau. */
    offTitleSkip: ['Your report and your plan are ready, {Name}.',
                   'Báo cáo và kế hoạch của bạn đã sẵn sàng, {Name}.'],

    /* Gói 2 — tài liệu 07/09/2026 trang 12, nguyên văn. Dòng đầu của gói 2 trong PDF là
       "✓ Everything in Map & Report"; nó đứng đầu danh sách 5 Giải pháp. */
    offGoi2Dau:    ['**Everything in Map & Report**', '**Toàn bộ gói 1**'],
    offPrice2:     ['MAP & REPORT + 5 SOLUTIONS · $19 · the complete reading · one payment · digital · yours to keep',
                    'Bản đồ & Báo cáo + 5 Giải pháp · $19 · bản đọc trọn bộ · trả một lần · bản đọc số · giữ trọn'],

    /* CHỮ NÀY DO CLAUDE VIẾT, marketing chưa duyệt — thay khi có bản chính thức.
       Hiện cho mọi khách đã bấm Skip, ở cả hai gói — cả hai đều bán phần Bản đồ. Phải nói
       TRƯỚC khi thu tiền rằng Bản đồ cần ngày sinh và thêm sau lúc nào cũng được; không có
       câu này thì lời mời điền ngày sinh sau khi trả tiền đọc như một cái bẫy. */
    offMapSau:  ['The map half needs your birth date. You skipped it, so add it any time after checkout and the map appears in your reading.',
                 'Phần Bản đồ cần ngày sinh của bạn. Bạn đã bỏ qua, nên thêm vào lúc nào cũng được sau khi thanh toán, Bản đồ sẽ hiện trong bản đọc.'],

    /* Tên mặc định khi ô tên trống — mục 4.4. Không bao giờ để lọt "For: you". */
    fallbackName: ['Friend', 'Bạn']
  };

  function G(k) { var v = GD1[k]; return isVI() ? v[1] : v[0]; }

  /* Dòng lợi ích: phần trong `**…**` là keyword, in đậm để mắt quét được thứ nhận về mà
     không phải đọc hết câu. Thoát chữ TRƯỚC rồi mới đổi dấu thành thẻ, nên chữ vẫn an
     toàn; chuỗi không có dấu thì giữ nguyên. Chữ bên trong không đổi một ký tự so với
     tài liệu — chỉ thêm nhấn. */
  function dam(chuoi) {
    return esc(chuoi).replace(/\*\*([^*]+)\*\*/g, '<b>$1</b>');
  }

  /* Khách bấm Skip ở màn ngày sinh — nhận diện bằng đúng một điều kiện, dùng ở cả màn
     kết quả lẫn khối chào hàng. `GS(k)` lấy bản `k + 'Skip'` cho nhánh đó. */
  function boQuaNgaySinh() { return !state.bdate; }
  function GS(k) { return G(boQuaNgaySinh() ? k + 'Skip' : k); }

  /* ══════════════════════════════════════════════════════════════════════════
     1 · KÊNH ĐO — mục 4.9
     Sáu event đi CÙNG `attempt_id`/`seq` với `quiz-do-duong.js`, không tự mint lượt riêng:
     hai lượt khác nhau cho cùng một khách là hỏng cả phễu. File kia phơi `window.__msSuKien`
     ra ngoài; nó chạy SAU file này nên event sớm phải đệm lại.
     ══════════════════════════════════════════════════════════════════════════ */
  var demEvent = [];

  /* Xả đệm. Không giữ cờ "đã xả" — hàm này rẻ và tự no-op khi chưa có kênh, còn một cờ
     chốt sai một lần là câm vĩnh viễn (xem bẫy `readyState` ở dưới). */
  function xaEvent() {
    if (typeof window.__msSuKien !== 'function') return;
    while (demEvent.length) {
      try { window.__msSuKien(demEvent.shift()); } catch (e) { /* Mất số, không mất đơn. */ }
    }
  }

  function suKien(ten, them) {
    var ev = { event: ten }, k;
    if (them) for (k in them) if (them.hasOwnProperty(k)) ev[k] = them[k];
    /* `utm_source` gắn thẳng vào từng event theo yêu cầu mục 4.9, dù `quiz-do-duong.js`
       đã gửi cả cụm `tracking` trong `meta`: câu SQL đọc bảng event không phải join. */
    var u = layUtm();
    if (u) ev.utm_source = u;
    demEvent.push(ev);
    xaEvent();
  }

  var KHOA_NGUON = 'minespirit_nguon';
  function layUtm() {
    try {
      var p = new URLSearchParams(location.search).get('utm_source');
      if (p) return String(p).slice(0, 512);
      var da = localStorage.getItem(KHOA_NGUON);
      if (da) { var o = JSON.parse(da); if (o && o.utm_source) return String(o.utm_source).slice(0, 512); }
    } catch (e) {}
    return '';
  }

  /* BẪY ĐÃ SẬP THẬT (08/09/2026, đo trên trình duyệt): thẻ `defer` chạy khi `readyState`
     đã là **"interactive"**, KHÔNG phải "loading" — DOMContentLoaded mới chỉ bắn SAU khi
     mọi thẻ defer chạy xong. Bản trước gác bằng `=== 'loading'` nên rơi vào nhánh else, gọi
     `xaEvent()` ngay lúc `quiz-do-duong.js` (#7) chưa chạy, kênh chưa có, cờ "đã xả" không
     bao giờ bật — cả sáu event nằm lại trong đệm suốt phiên, không lỗi nào báo.
     Chỉ "complete" mới là đã qua DOMContentLoaded. */
  if (document.readyState === 'complete') {
    xaEvent();
  } else {
    document.addEventListener('DOMContentLoaded', xaEvent);
  }

  /* ══════════════════════════════════════════════════════════════════════════
     2 · MỤC 4.6 · CHO TẦNG TIM VÀO CUỘC ĐUA edge/edge2/strength

     Bundle cố ý loại tim (`quiz-inner-weather.js:3172-3184`): với hồ sơ mẫu Margaret,
     min(give,receive)=1,5 < nền 1,7 nên tim sẽ thành tầng mỏng nhất, TRÁI với báo cáo mẫu.
     Chủ dự án đã chốt sửa theo tài liệu (33% khách là HEART_OVERLOADED mà không bao giờ
     được gọi tên vùng yếu).

     KHÔNG phải vá `res7()`. `QUIZ7.score` (lớp cuối, :23713) đọc `QUIZ7.ranked` LÚC CHẠY,
     nên thêm 'heart' vào mảng đó là đủ để tim ĐƯỢC đua. Chèn đúng vị trí 4 của cột — luật
     phá hoà là "tầng THẤP HƠN trong cột thắng", chèn cuối mảng là đổi luật đó cho mọi ca
     hoà điểm.

     GIÁ TRỊ ĐUA LÀ `min(give, receive)`, KHÔNG PHẢI `axes.heart` = mid.
     Bản đầu (review PR #113 · F1) để tim đua bằng mid và như thế SAI hai lần:
       · Lệch máy chủ. `mine_chapter` PR #203 (`QUIZ_ENGINE_VERSION = "v2"`, hàm
         `rankAxisVals_`) cho tim đua bằng min, giữ `axes.heart` = mid cho chỉ số tổng và
         biên độ. Hai bên trả `edge` khác nhau cho cùng một khách: màn kết quả gọi tên một
         vùng, bản đọc do API dựng gọi tên vùng khác.
       · Gần như là no-op. Đúng nhóm khách mà bản sửa này nhắm tới — HEART_OVERLOADED,
         `give >= 7` và `receive <= 3` — có mid quanh 5, gần như không bao giờ nhỏ nhất.
     min mới là bản đúng: chính chú thích của bundle (:3172-3184) chép lại đặc tả gốc là
     "§4 đặt axes.heart = min(give,receive) rồi cho tim vào cuộc đua" — engine cũ LOẠI tim
     ra chứ không đổi phép đo.

     CÁCH TÁCH GIÁ TRỊ ĐUA MÀ KHÔNG CHÉP THUẬT TOÁN.
     `QUIZ7.score` đọc giá trị đua thẳng từ `axes[R[i]]` ngay trong ba vòng lặp xếp hạng
     (:23749-23759) — không có hàm nào để đè. Chép lại ba vòng đó là chép luôn luật phá hoà
     ("hoà thì tầng thấp hơn thắng", "cao nhất thì tầng cao hơn thắng"), và hai bản sao ấy
     sẽ lệch nhau ở lần bundle sửa đầu tiên.

     Nên chạy `score` HAI LƯỢT, để chính bundle xếp hạng cả hai lần:
       lượt 1 — nguyên bản: lấy mọi thứ (index, band, spread, mode, tiers, give, receive).
       lượt 2 — đè `QUIZ7.pointsOf` cho riêng câu tầng tim trả về `min(give, receive)`.
                Khi đó `avg(give) = avg(receive) = min` nên `axes.heart` của lượt này BẰNG
                min, và ba vòng xếp hạng của bundle tự cho ra edge/edge2/strength theo min.
     Lấy đúng ba giá trị đó ghép vào lượt 1. Không một dòng thuật toán nào bị chép, và bundle
     đổi luật phá hoà thì cả hai lượt đổi theo.
     `pointsOf` được trả lại trong `finally` — rò ra ngoài là mọi điểm số sau đó đều sai. */
  (function timVaoCuoc() {
    if (!QUIZ7.ranked || !QUIZ7.order || typeof QUIZ7.score !== 'function') return;

    /* 1 · cho tim VÀO cuộc đua, đúng vị trí 4 của cột */
    if (QUIZ7.ranked.indexOf('heart') < 0) {
      var moi = [], i;
      for (i = 0; i < QUIZ7.order.length; i++) {
        if (QUIZ7.order[i] === 'heart' || QUIZ7.ranked.indexOf(QUIZ7.order[i]) >= 0) moi.push(QUIZ7.order[i]);
      }
      QUIZ7.ranked = moi;
    }

    /* Khoá câu hỏi tầng tim lấy từ chính bảng của quiz, không viết cứng 'Q8'/'Q9': bộ đề
       đã đổi bốn lần trong hai tuần. */
    var CAU_TIM = {};
    for (var j = 0; j < QUIZ7.questions.length; j++) {
      if (QUIZ7.questions[j].tier === 'heart') CAU_TIM[QUIZ7.questions[j].id] = 1;
    }

    /* 2 · đổi GIÁ TRỊ ĐUA của tim sang min(give, receive) */
    var scoreGoc = QUIZ7.score;
    QUIZ7.score = function (answers) {
      var r = scoreGoc.call(this, answers);
      if (!r || typeof r.give !== 'number' || typeof r.receive !== 'number') return r;

      var m = Math.min(r.give, r.receive);
      var ptsGoc = QUIZ7.pointsOf, r2 = null;
      QUIZ7.pointsOf = function (qid, idx) {
        return CAU_TIM[qid] ? m : ptsGoc.call(this, qid, idx);
      };
      try { r2 = scoreGoc.call(this, answers); }
      catch (e) { r2 = null; }              /* Hỏng lượt 2 thì giữ nguyên lượt 1, đừng vỡ quiz. */
      finally { QUIZ7.pointsOf = ptsGoc; }

      if (r2 && r2.edge) {
        r.edge = r2.edge;
        r.edge2 = r2.edge2;
        r.strength = r2.strength;
        r.stone = QUIZ7.stoneOf(r.edge);
        r.stone2 = QUIZ7.stoneOf(r.edge2);
      }
      return r;
    };

    /* 3 · dựng lại `QUIZ7.EXPECTED` bằng ĐÚNG biểu thức ở :23779.
       Bản đầu gán `null` (review F2). Lý do thì đúng — `EXPECTED` chốt lúc nạp file bằng
       mảng `ranked` CŨ nên `edge` trong đó đã cũ — nhưng `null` biến một công cụ BÁO LỆCH
       thành một công cụ HỎNG: `selfTest()` (:3346) đọc `E.root`, `E.edge`… nên ném
       `TypeError` thay vì in ra dòng lệch. Tính lại thì selfTest vẫn chạy, vẫn so được. */
    try {
      if (QUIZ7.MARGARET) {
        var rm = QUIZ7.score(QUIZ7.MARGARET);
        QUIZ7.EXPECTED = {
          root: rm.tiers.root, joy: rm.tiers.joy, boundaries: rm.tiers.boundaries,
          give: rm.tiers.heart.give, receive: rm.tiers.heart.receive,
          voice: rm.tiers.voice, mind: rm.tiers.mind, meaning: rm.tiers.meaning,
          edge: rm.edge, edge2: rm.edge2
        };
      }
    } catch (e) { /* Không dựng lại được thì để nguyên bản cũ — vẫn hơn `null`. */ }
  })();

  /* ══════════════════════════════════════════════════════════════════════════
     3 · MỤC 4.1 · XƯNG HÔ MẶC ĐỊNH "just by my name" CHO MỌI KHÁCH

     Màn hỏi xưng hô bị bỏ (mục 2). `PRO()` đọc `state.gender` và mặc định của nó là
     `undefined` → `proVi[undefined] || proVi[0]` = "chị". Khách nam đọc bản VI sẽ bị gọi
     "chị" mà không có đường nào nói khác. Chỉ số 2 = "Cứ gọi bằng tên tôi" → "bạn".

     KHÔNG ghi `state.q7.GENDER`: bộ đề lên v3.1 = v3 TRỪ câu GENDER, gửi đáp án cho một
     câu không còn trong bộ đề là lệch phiên bản.
     ══════════════════════════════════════════════════════════════════════════ */
  var CHI_SO_TEN_RIENG = 2;

  function datXungHo() {
    try {
      if (state.gender !== CHI_SO_TEN_RIENG) state.gender = CHI_SO_TEN_RIENG;
      if (state.q7 && state.q7.GENDER !== undefined) delete state.q7.GENDER;
    } catch (e) {}
  }
  datXungHo();

  /* `freshState()` (Start over) không đụng `state.gender` — nó nằm ngoài object trả về —
     nhưng bốn chỗ Start over gán `state = freshState()`, tức `state.gender` về `undefined`.
     Bọc để mọi lượt sau vẫn đúng xưng hô. */
  if (typeof freshState === 'function') {
    var freshGoc = freshState;
    freshState = function () {
      var s = freshGoc.apply(this, arguments);
      s.gender = CHI_SO_TEN_RIENG;
      return s;
    };
  }

  /* ══════════════════════════════════════════════════════════════════════════
     3b · CHỮ TRONG MỌI NÚT `.btn` NẰM GỌN MỘT DÒNG (yêu cầu 08/09/2026)

     iPhone X/11 rộng 375px làm "GET MY REPORT & MY PLAN" gãy đôi. CSS đã cấm xuống dòng
     (`white-space: nowrap`); hàm này hạ cỡ chữ từng nửa điểm cho tới khi chữ vừa khung,
     sàn 13px. Theme ép `font-size … !important` cho `.btn`, nên inline cũng phải
     `!important` mới thắng. Chạy sau MỖI lần dựng màn (bọc `bindShell`, cùng lối với
     `freshState` ở trên) và khi khối chào hàng mở ra — lúc dựng nó còn `hidden`, đo ra 0.
     ══════════════════════════════════════════════════════════════════════════ */
  /* 29/09/2026: nút có giá (`.cogia`, nhãn dựng bằng `a1NutGia()` trong
     quiz-bo-de-dung-man.js) chỉ ép KHÚC CHỮ `.nutchu` nằm một dòng; khúc giá được xuống
     dòng 2. Đo lại sau khi font web tải xong — đo lúc còn font dự phòng là trượt (chữ tràn
     mép nút trên iPhone 375px). `window.__msGonNut` cho chỗ khác gọi khi nút vừa hiện. */
  /* Đo bề rộng CHỮ so với LÒNG nút (trừ đệm), không dùng `scrollWidth`: chữ lấn vào phần
     đệm thì `scrollWidth` chưa báo tràn, nhưng trình duyệt đã bỏ canh giữa — chữ lệch phải. */
  function tranNut(b) {
    var chu = b.querySelector('.nutchu'), r = document.createRange();
    r.selectNodeContents(chu || b);
    var cs = getComputedStyle(b);
    var long = b.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
    return r.getBoundingClientRect().width > long + 0.5;
  }
  function gonNut(goc) {
    var ds = (goc || document).querySelectorAll('.btn');
    for (var i = 0; i < ds.length; i++) {
      var b = ds[i];
      b.style.removeProperty('font-size');
      if (!b.offsetWidth) continue;
      var co = parseFloat(getComputedStyle(b).fontSize) || 17, lan = 0;
      while (tranNut(b) && co > 13 && lan++ < 40) {
        co -= 0.5;
        b.style.setProperty('font-size', co + 'px', 'important');
      }
    }
  }
  window.__msGonNut = gonNut;
  if (typeof bindShell === 'function') {
    var bindShellGoc = bindShell;
    bindShell = function () {
      var r = bindShellGoc.apply(this, arguments);
      gonNut();
      return r;
    };
  }
  try { document.fonts.ready.then(function () { gonNut(); }); } catch (e) {}

  /* Mục 4.4 · tên trống → giá trị mặc định. Gọi trước mọi màn có chữ {name}. */
  function chotTen() {
    try {
      var t = (state.name || '').trim();
      if (!t) {
        state.name = G('fallbackName');
        state.fullName = state.fullName || state.name;
      }
    } catch (e) {}
    return state.name;
  }

  /* ══════════════════════════════════════════════════════════════════════════
     4 · MỤC 1 · MÀN INTRO — chỉ đổi chữ
     Giữ hình viên đá (`.moonart`), bố cục, công tắc EN/VI và nút loa (`topbar()`).
     ══════════════════════════════════════════════════════════════════════════ */
  /* ══════════════════════════════════════════════════════════════════════════
     Bọc ô nhập trong <form> — điều kiện còn thiếu của autofill

     Thẻ `autocomplete` đúng loại mới là một nửa. Gợi ý từ DANH BẠ / hồ sơ trình duyệt
     (khác với gợi ý từ kho mật khẩu — kho đó chỉ có dữ liệu cho trang từng đăng nhập)
     được Safari và Chrome dựng theo cả CỤM ô, và cụm đó chúng nhận qua thẻ `<form>`.
     Ba màn này trước giờ chỉ có `div`, nên không có cụm nào để nhận.

     `formShell` để nút Continue ở `.foot`, tức NGOÀI form. Hệ quả có thật, không phải
     lo xa: form một ô sẽ submit khi bấm Enter (implicit submission), mà submit thì nạp
     lại trang và khách mất sạch câu trả lời. `afBind` chặn đúng chỗ đó, và đổi Enter
     thành bấm Continue — thứ khách vẫn tưởng Enter sẽ làm.

     `novalidate` để bong bóng "Please fill out this field" của trình duyệt không đè lên
     dòng lỗi tiếng Việt/Anh mà quiz tự viết. ────────────────────────────────────── */
  function afForm(inner) {
    return '<form id="af" class="gd1-af" novalidate>' + inner + '</form>';
  }

  function afBind(go) {
    var f = $('af');
    if (!f) return;
    f.onsubmit = function (ev) {
      ev.preventDefault();
      if (go && !go.disabled) go.click();
    };
  }

  /* A1 (phase 19) viết lại HẲN màn 1 trong `quiz-bo-de-dung-man.js` rồi cắm cờ `__msMan19`.
     File này nạp ở thẻ #6, SAU overlay đó, nên gán tiếp là ném bản v7.9 đi trong im lặng — đo
     21/09 trên theme development: `RENDER.intro.toString()` trả về đúng hàm dưới đây và màn 1
     vẫn in ba chuỗi mà phase 19 phải bỏ.
     Cờ RIÊNG, không dùng chung `__msManA0` của phase 18: hai lớp gác hai thứ khác nhau (A0 gác
     `SCREENS`, A1 gác `RENDER.intro`) và phải bật tắt độc lập được.
     KHÔNG xoá hẳn hàm này: snapshot vắng hoặc sai dạng thì overlay thoát sớm, không cắm cờ
     nào, và đây là màn 1 duy nhất còn lại. Quả cầu `.moonart` bỏ theo v7.9. */
  if (!window.__msMan19) {
    RENDER.intro = function () {
      return {
        html: topbar() +
          '<div class="mid center">' +
            '<div class="kicker">' + esc(G('introKick')) + '</div>' +
            '<h1 class="big">' + esc(G('introTitle')) + '</h1>' +
            '<p class="sub gd1-introsub">' + esc(G('introSub')) + '</p>' +
          '</div>' +
          '<div class="foot"><button class="btn" id="go">' + esc(G('introBtn')) + '</button>' +
          '<p class="tiny">' + esc(G('introTiny')) + '</p></div>',
        bind: function () { $('go').onclick = function () { sfx('tap'); next(); }; }
      };
    };
  }

  /* ══════════════════════════════════════════════════════════════════════════
     5 · MỤC 2 · NGÀY SINH — dòng phụ mới + nút Skip NGANG HÀNG với Continue

     Chép logic kiểm số của lớp cuối (`:21424`) chứ không bọc nó: cần thay cả kicker, thêm
     dòng phụ và đổi khối nút, tức thay gần hết `html`. Bọc rồi vá DOM thì lần bundle đổi
     markup là vá rơi câm — đúng bài học `quiz-sang-trang-ban.js` đã trả giá.

     A5 (phase 23) viết lại HẲN màn ngày sinh và màn email trong `quiz-bo-de-dung-man.js`
     rồi cắm cờ `__msMan23`. File này nạp ở thẻ #6, SAU overlay đó, nên gán tiếp là ném bản
     v7.9 đi trong im lặng — đúng như `__msMan19` đã phải gác cho màn 1.
     Cờ RIÊNG, không dùng chung `__msManA0` hay `__msMan19`: ba lớp gác ba thứ khác nhau và
     phải bật tắt độc lập được.
     KHÔNG xoá hai hàm dưới: snapshot vắng hoặc sai dạng thì overlay thoát sớm, không cắm
     cờ nào, và đây là hai màn duy nhất còn lại.
     ══════════════════════════════════════════════════════════════════════════ */
  if (!window.__msMan23) {
  RENDER.bdate = function () {
    var b = state.bdate || {};
    var F = {
      m: { id: 'bm', lab: 'Month', ph: 'MM',   max: 2, ac: 'bday-month', v: b.m ? String(b.m) : '' },
      d: { id: 'bd', lab: 'Day',   ph: 'DD',   max: 2, ac: 'bday-day',   v: b.d ? String(b.d) : '' },
      y: { id: 'by', lab: 'Year',  ph: 'YYYY', max: 4, ac: 'bday-year',  v: b.y ? String(b.y) : '' }
    };
    /* Mỹ viết Tháng/Ngày/Năm, Việt viết Ngày/Tháng/Năm */
    var order = isVI() ? ['d', 'm', 'y'] : ['m', 'd', 'y'];

    /* `name` + `autocomplete` là hai thứ trình duyệt cần để mở gợi ý đã lưu. Bản gốc
       khai `autocomplete="off"` nên Safari/Chrome im lặng — mà đây đúng là chỗ khách
       rớt nhiều nhất, gõ tay bốn đến sáu chữ số. Token `bday-*` là chuẩn HTML, mỗi ô
       một token, không phải tên tự đặt. */
    var boxes = order.map(function (k) {
      var f = F[k];
      return '<div><label class="lab" for="' + f.id + '">' + esc(T(f.lab)) + '</label>' +
        '<input class="inp numin" id="' + f.id + '" inputmode="numeric" pattern="[0-9]*" ' +
          'name="' + f.ac + '" autocomplete="' + f.ac + '" ' +
          'maxlength="' + f.max + '" placeholder="' + f.ph + '" ' +
          'value="' + esc(f.v) + '"></div>';
    }).join('');

    return {
      html: formShell('', esc(G('bdateTitle')),
        '<p class="sub gd1-formsub">' + esc(G('bdateSub')) + '</p>' +
        afForm('<div class="dgrid d3">' + boxes + '</div>') +
        '<div class="decho" id="decho"></div>' +
        '<div class="derr" id="derr"></div>' +
        /* Giữ dòng gợi ý của bản cũ. Bảng "BẢN MỚI" ở mục 2 chỉ liệt kê Tiêu đề · Dòng phụ ·
           Ô · Nút — bảng "BẢN GỐC" ngay cạnh cũng không liệt kê dòng này, tức bảng không
           kể hết mọi thành phần trên màn. Tài liệu không nói bỏ thì không bỏ. */
        '<p class="dhint">' + esc(T('Type the numbers. No calendar to scroll.')) + '</p>',
        '<div class="gd1-2btn">' +
          '<button class="btn" id="go" disabled>' + esc(G('bdateGo')) + '</button>' +
          '<button class="btn ghost" id="skip">' + esc(G('bdateSkip')) + '</button>' +
        '</div>', MICRO()),
      bind: function () {
        var mm = $('bm'), dd = $('bd'), yy = $('by'), go = $('go');
        var echo = $('decho'), err = $('derr');
        v8fChain(order.map(function (k) { return $(F[k].id); }));

        function chk() {
          var m = +v8fNum(mm), d = +v8fNum(dd), y = +v8fNum(yy);
          var thisYear = new Date().getFullYear();
          [mm, dd, yy].forEach(function (e) { e.classList.remove('bad'); });
          echo.textContent = ''; err.textContent = '';

          /* chưa gõ xong thì im lặng — mắng người ta giữa chừng là mất bình tĩnh */
          var done = mm.value && dd.value && yy.value.length === 4;
          if (!done) { go.disabled = true; return; }

          if (!(m >= 1 && m <= 12)) { mm.classList.add('bad'); err.textContent = T('Please check the month (1–12).'); go.disabled = true; return; }
          if (!(y >= 1900 && y <= thisYear)) { yy.classList.add('bad'); err.textContent = T('Please check the year.'); go.disabled = true; return; }
          if (!(d >= 1 && d <= v8fDim(y, m))) { dd.classList.add('bad'); err.textContent = T('Please check the day.'); go.disabled = true; return; }

          echo.textContent = isVI() ? (d + ' ' + v8fMonthName(m) + ', ' + y)
                                    : (v8fMonthName(m) + ' ' + d + ', ' + y);
          go.disabled = false;
        }

        [mm, dd, yy].forEach(function (e) { e.oninput = chk; e.onchange = chk; });
        chk();
        afBind(go);

        go.onclick = function () {
          var m = +mm.value, d = +dd.value, y = +yy.value;
          var p2 = function (n) { return (n < 10 ? '0' : '') + n; };
          state.bdate = { y: y, m: m, d: d, raw: y + '-' + p2(m) + '-' + p2(d) };
          sfx('tap'); next();
        };
        /* Bỏ qua: XOÁ hẳn ngày sinh chứ không để nguyên giá trị cũ. Khách bấm back rồi
           bấm Skip mà vẫn còn ngày cũ thì lời nhận xét đi nhánh "có ngày sinh" trong khi
           khách tin là mình đã bỏ qua. */
        $('skip').onclick = function () {
          state.bdate = null;
          sfx('tap'); next();
        };
      }
    };
  };

  /* ── MỤC 2 · TÊN — bỏ dòng phụ, ô đổi thành "Your first name" ─────────────── */
  RENDER.name = function () {
    return {
      html: formShell('', L('What should we <span style="color:var(--gold)">call you</span>?',
                             'Chúng tôi nên <span style="color:var(--gold)">gọi bạn</span> là gì?'),
        /* `autocomplete="name"` thay cho `off`: xem ghi chú ở ô ngày sinh. */
        afForm('<div class="field"><label class="lab" for="n">' + esc(G('nameField')) + '</label>' +
        '<input class="inp" type="text" id="n" name="name" autocomplete="name" value="' + esc(state.fullName || state.name || '') + '"></div>'),
        '<button class="btn" id="go" disabled>' + esc(G('nameGo')) + '</button>', ''),
      bind: function () {
        var n = $('n'), go = $('go');
        function chk() { go.disabled = n.value.trim().length < 2; }
        n.oninput = chk; chk();
        afBind(go);
        go.onclick = function () {
          state.fullName = n.value.trim();
          state.name = state.fullName.split(/\s+/)[0];
          sfx('tap'); next();
        };
      }
    };
  };

  /* ── MỤC 2 · EMAIL — tiêu đề có {Name}, dòng phụ và nút mới ───────────────── */
  RENDER.email = function () {
    chotTen();
    var tieuDe = G('emailTitle').replace('{Name}', state.name);
    return {
      html: formShell('', esc(tieuDe),
        /* `autocomplete="email"` thay cho `off`: xem ghi chú ở ô ngày sinh. Ô này là
           màn cuối trước khi tính điểm, gõ sai một ký tự là mất luôn khách. */
        afForm('<div class="field"><label class="lab" for="e">' + esc(G('emailField')) + '</label>' +
        '<input class="inp" type="email" id="e" name="email" placeholder="' + esc(T('you@email.com')) + '" autocomplete="email" inputmode="email" value="' + esc(state.email) + '">' +
        '<div class="err" id="err"></div></div>'),
        '<button class="btn" id="go" disabled>' + esc(G('emailGo')) + '</button>',
        esc(G('emailSub'))),
      bind: function () {
        var e = $('e'), go = $('go'), err = $('err');
        function chk() {
          var ok = EMAIL_RE.test(e.value.trim());
          go.disabled = !ok;
          err.textContent = (e.value.trim() && !ok) ? T('That address does not look complete.') : '';
          return ok;
        }
        e.oninput = chk; e.onblur = chk; chk();
        afBind(go);
        go.onclick = function () { if (chk()) { state.email = e.value.trim(); sfx('tap'); next(); } };
      }
    };
  };
  }  /* hết cổng `__msMan23` */

  /* ══════════════════════════════════════════════════════════════════════════
     6 · MỤC 4.5 · {NextMonth} và {Weeks} — THÁNG LẤY TỪ MÁY CHỦ

     K4 đòi quiz và bản đọc nói CÙNG một tháng. Nên tháng không còn tính trong trình duyệt
     bằng hàm xếp 12 thẻ tháng của bundle (`quiz-inner-weather.js:24530`) nữa: đó là nguồn
     thứ hai, và hai nguồn chính là thứ K4 muốn bỏ. Giờ hỏi
     `GET /api/quiz/months?session_id=<uuid>` (hợp đồng C12):

         [ { "year": 2026, "month": 11, "tier": "voice", "brings": "…", "prepare": "…" } ]

     Luôn là MỘT MẢNG, kể cả khi rỗng. Máy chủ đã làm sẵn hai việc mà `theHan()` cũ không
     có — cắt trần ở tháng hiện tại + 2, và chỉ giữ tháng thuộc vùng `edge`/`edge2` của
     chính khách — nên việc còn lại ở đây chỉ là chọn tháng SỚM NHẤT trong mảng. Đừng chép
     lại hai luật đó xuống đây: một bản sao là một chỗ để lệch.

     MẢNG RỖNG LÀ CHUYỆN THƯỜNG, KHÔNG PHẢI LỖI. Engine chỉ đánh dấu theo transit hành tinh
     chậm, vài lần mỗi thập kỷ, nên phần lớn khách không có tháng nào trong cửa sổ ba tháng.
     Rỗng, mạng hỏng, timeout, 5xx, JSON hỏng — tất cả đều ra `null`, và `null` đúng là hợp
     đồng CŨ của `theHan()`: màn kết quả tự đổi ô tháng thành ô "First step · tonight", câu
     tháng tự rơi về bản không có mốc. Không một chỗ gọi nào phải sửa. Tuyệt đối KHÔNG rơi
     về đường tính trong trình duyệt làm lớp dự phòng.

     GỌI Ở MÀN `calc`, KHÔNG PHẢI LÚC VẼ MÀN KẾT QUẢ. `RENDER.hub` dựng HTML đồng bộ; đợi
     mạng ở đó là hoặc trắng màn hoặc luôn trượt. Màn `calc` chạy thanh tiến trình gần mười
     giây — đủ cho cả lượt lấy mã phiên lẫn lượt hỏi tháng.

     MÃ PHIÊN CHƯA CÓ LÚC ĐỨNG Ở `calc`. `quiz-goi-api.js` chỉ gọi `gui()` khi màn kết quả
     dựng, tức SAU `calc`. Nên ở đây phải tự khởi động nó qua `window.__msGuiLai()` — đúng
     cái cửa nút mua đang dùng — rồi đợi `window.__msPhienDangBay`. `gui()` tự chặn gọi
     trùng theo mã lượt, nên lượt bọc ở màn kết quả sau đó là vô hại.

     KHÁCH BẤM SKIP NGÀY SINH THÌ KHÔNG GỌI GÌ CẢ: C12 mục 3 nói máy chủ chắc chắn trả `[]`,
     nên một lượt mạng ở đó chỉ tốn hạn mức, và nhánh đó giữ nguyên lúc gửi bài như cũ.

     {Weeks} = số tuần tới ngày 1 của tháng đó, CHỈ dùng khi <= 8.
     ══════════════════════════════════════════════════════════════════════════ */
  var THANG_EN = ['', 'January', 'February', 'March', 'April', 'May', 'June',
                  'July', 'August', 'September', 'October', 'November', 'December'];

  /* Gốc API lấy từ chính thẻ `#phone` mà `quiz-goi-api.js` đọc — file kia không phơi nó ra
     ngoài, và đoán một gốc khác là đoán sai ở môi trường thử. Chưa khai thì không gọi. */
  var GOC_API = (function () {
    var o = document.getElementById('phone');
    return o ? (o.getAttribute('data-goc-api') || '').replace(/\/+$/, '') : '';
  })();

  var THANG_TOI_DA_MS = 6000;
  var DANG_UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

  /* Đọc mã phiên ĐÚNG hợp đồng của `quiz-sang-trang-ban.js`: sessionStorage thắng
     localStorage, và phải đúng định dạng — mã rác làm máy chủ trả 400. */
  function layPhien() {
    try {
      var v = (sessionStorage.getItem('minespirit_phien') ||
               localStorage.getItem('minespirit_phien') || '').trim();
      return DANG_UUID.test(v) ? v : '';
    } catch (e) { return ''; }
  }

  /* Mã lượt do `quiz-do-duong.js` mint mỗi lần tải trang và mỗi lần Start over. Dùng làm
     khoá nhớ: đổi lượt là phải hỏi lại tháng, đừng giữ tháng của lượt trước. */
  function layLuot() {
    try { return sessionStorage.getItem('minespirit_luot') || ''; } catch (e) { return ''; }
  }

  /* MÃ PHIÊN CÒN NẰM LẠI TỪ LƯỢT TRƯỚC LÀ MÃ SAI, KHÔNG PHẢI MÃ THIẾU.
     `minespirit_phien` sống ở localStorage nên qua được cả lần tải trang, còn
     `minespirit_luot` ở sessionStorage thì mint mới mỗi lần tải trang và mỗi lần Start over.
     Khách làm lại bài là có ngay một mã phiên CŨ trong tay. `quiz-goi-api.js` dọn nó ở đầu
     `gui()` (so `minespirit_phien_luot` với lượt hiện tại) — nhưng `gui()` chưa chạy lúc
     đứng ở `calc`, nên ở đây phải tự xét, nếu không thì hỏi tháng của bài LẦN TRƯỚC và in
     một tháng không thuộc bản đọc khách sắp mua: đúng cái K4 muốn bỏ. */
  function phienCuaLuot(luot) {
    var ma = layPhien();
    if (!ma) return '';
    try { return localStorage.getItem('minespirit_phien_luot') === luot ? ma : ''; }
    catch (e) { return ''; }
  }

  var thangLuot = null;      /* lượt đã hỏi (kể cả đang bay) */
  var thangChon = null;      /* { nam, thang } của lượt đó, hoặc null */

  function hongThang(vi) {
    suKien('month_api_failed', { screen: 'calc', question_id: vi });
  }

  /* Tháng SỚM NHẤT trong mảng. Không tin thứ tự máy chủ trả về — C12 không hứa thứ tự nào,
     mà "gần nhất" là chính luật chọn của K4. Phần tử thiếu `year`/`month` thì bỏ qua. */
  function chonThang(ds) {
    var ra = null, i, t;
    for (i = 0; i < ds.length; i++) {
      t = ds[i];
      if (!t || typeof t.year !== 'number' || typeof t.month !== 'number') continue;
      if (!ra || t.year < ra.nam || (t.year === ra.nam && t.month < ra.thang)) {
        ra = { nam: t.year, thang: t.month };
      }
    }
    return ra;
  }

  function hoiThang(ma) {
    var xong, da = false;
    var p = new Promise(function (r) { xong = r; });
    var h = setTimeout(function () { ket(null, 'timeout'); }, THANG_TOI_DA_MS);

    /* Một lối ra duy nhất: hết giờ rồi mạng mới trả lời thì không được bắn event lần hai,
       cũng không được ghi đè câu trả lời đã chốt. */
    function ket(t, vi) {
      if (da) return;
      da = true;
      clearTimeout(h);
      if (vi) hongThang(vi);
      xong(t);
    }

    fetch(GOC_API + '/api/quiz/months?session_id=' + encodeURIComponent(ma),
          { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) { ket(null, 's' + r.status); return; }
        return r.text().then(function (chu) {
          var ds = null;
          try { ds = JSON.parse(chu); } catch (e) {}
          if (!ds || !Array.isArray(ds)) { ket(null, 'parse'); return; }
          ket(chonThang(ds));
        });
      })
      ['catch'](function () { ket(null, 'network'); });

    return p;
  }

  function napThang() {
    var luot = layLuot();
    if (thangLuot === luot) return;       /* lượt này đã hỏi rồi */
    thangLuot = luot;
    thangChon = null;
    /* `window.__msThangXong`: lời hứa xong-lượt-hỏi-tháng (có tháng, không có, hay hỏng đều
       tính là xong). Màn `calc` (quiz-bo-de-dung-man.js) đọc nó để sang màn kết quả ngay khi
       mạng đã trả lời, thay vì luôn chờ đủ cửa sổ 14,4 giây (yêu cầu 29/09/2026). */
    if (!state.bdate || !GOC_API) { window.__msThangXong = Promise.resolve(); return; }

    var bay = window.__msPhienDangBay;
    if (!phienCuaLuot(luot) && !bay && typeof window.__msGuiLai === 'function') {
      try { bay = window.__msGuiLai(); } catch (e) { bay = null; }
    }

    window.__msThangXong = Promise.resolve(bay || null)
      ['catch'](function () { return null; })
      .then(function () {
        var ma = phienCuaLuot(luot);
        if (!ma) { hongThang('no_session'); return null; }
        return hoiThang(ma);
      })
      .then(function (t) {
        /* Start over giữa lúc đang bay đã đổi lượt — câu trả lời này thuộc lượt cũ. */
        if (thangLuot === luot) {
          thangChon = t;
          try { sessionStorage.setItem(KHOA_THANG, JSON.stringify({ luot: luot, t: t })); } catch (e) {}
        }
      })
      ['catch'](function () {});
  }

  /* Bọc `RENDER.calc` — đúng lối `quiz-goi-api.js` bọc `RENDER.hub`. Màn `calc` dựng lại
     (vẽ lại màn đang hiện, `?screen=`) thì `napThang()` tự chặn theo mã lượt. */
  (function bocManTinh() {
    if (typeof RENDER.calc !== 'function') return;
    var goc = RENDER.calc;
    RENDER.calc = function () {
      try { napThang(); } catch (e) {}
      return goc.apply(this, arguments);
    };
  })();

  /* Hợp đồng GIỮ NGUYÊN: `null` khi không có tháng, `{ nam, thang }` khi có. Đồng bộ, đọc ô
     nhớ mà màn `calc` đã đổ đầy — chỗ gọi vẫn dựng HTML ngay như trước.
     Vào thẳng màn kết quả bằng `?demo=`/`?screen=` là không đi qua `calc`, nên không có
     tháng: đúng luật một nguồn, màn demo rơi về ô "First step · tonight". */
  /* Tải lại cùng tab ở màn 36/37 thì lượt đi tiếp mà không qua màn `calc` lần nữa, và ô nhớ
     memory ở trên đã trắng. Đọc lại tháng đã hỏi của ĐÚNG lượt đó từ `sessionStorage`. */
  var KHOA_THANG = 'minespirit_thang';

  function theHan() {
    if (!state.bdate) return null;
    var luot = layLuot();
    if (thangLuot === luot) return thangChon;
    try {
      var o = JSON.parse(sessionStorage.getItem(KHOA_THANG) || 'null');
      if (o && o.luot === luot && o.t && typeof o.t.nam === 'number') return o.t;
    } catch (e) {}
    return null;
  }

  /* Màn 36 v7.9 (`a6Thang()` trong `quiz-bo-de-dung-man.js`) đọc tháng qua cửa này, để cả
     quiz chỉ có MỘT nguồn tháng là `/api/quiz/months`. Phơi HÀM chứ không phơi giá trị: câu
     trả lời về bất đồng bộ sau màn `calc`, gọi lúc dựng màn là đọc được ô nhớ mới nhất. */
  window.__msThangHan = theHan;

  function chuThang(t) {
    return isVI() ? (t.thang + '/' + t.nam) : (THANG_EN[t.thang] + ' ' + t.nam);
  }

  var MS_TUAN = 7 * 24 * 60 * 60 * 1000;

  /* Số tuần tới NGÀY 1 của tháng đó. Trả 0 khi tháng ấy đã bắt đầu — cửa sổ của máy chủ
     mở từ CHÍNH THÁNG NÀY (C12 mục 1), nên mốc có thể nằm sau lưng. Gọi hàm
     phải hiểu 0 nghĩa là "không có con số nào để nói" và đi nhánh không có {Weeks};
     kẹp về 1 rồi in "1 weeks from now" cho một tháng đang diễn ra là nói sai với khách. */
  function soTuan(t) {
    var now = new Date();
    var moc = new Date(t.nam, t.thang - 1, 1);
    var n = Math.round((moc - now) / MS_TUAN);
    return n < 1 ? 0 : n;
  }

  /* ══════════════════════════════════════════════════════════════════════════
     7 · MỤC 3.2b · BẢY NHÃN KIỂU NGƯỜI — chữ mới, LUẬT CHỌN GIỮ NGUYÊN

     Điều kiện lấy đúng cột "ĐIỀU KIỆN (ENGINE)" của bảng 3.2b, xét từ trên xuống.
     LỆCH ĐÃ BIẾT: `v10rType` trong bundle (:24313 và :24753) chỉ có 5 nhánh — thiếu hai
     nhánh theo tổng điểm (>= 7,5 và >= 6). Tài liệu liệt kê đủ 7, và mô phỏng ở 3.2b nói
     rõ "mô phỏng dùng nhãn 7 vì tổng điểm mẫu ở dải 4–7", tức hai nhánh tổng điểm là có
     thật trong luật. Dựng đủ 7 ở đây; ba nhánh đầu và nhánh cuối trùng khít bundle.
     ══════════════════════════════════════════════════════════════════════════ */
  var NHAN = [
    ['THE ONE WHO GIVES AND GETS LITTLE BACK', 'Người cho đi mà nhận lại chẳng bao nhiêu'],
    ['THE ONE WHO NEVER FULLY RESTS',          'Người chưa bao giờ được nghỉ hẳn'],
    ['THE ONE WHO HOLDS BACK WHAT NEEDS SAYING', 'Người giữ lại điều cần nói'],
    ['THE ONE WHO KEEPS NOTHING FOR HERSELF',  'Người không giữ lại gì cho riêng mình'],
    ['THE ONE WHO IS STEADY, WITH ONE AREA TO WATCH', 'Người đang vững, còn một vùng cần để mắt'],
    ['THE ONE WHO IS HOLDING ON BUT LOSING ENERGY', 'Người đang giữ được nhưng đang mất năng lượng'],
    ['THE ONE WHO IS RUNNING ON EMPTY',        'Người đang chạy bằng bình cạn']
  ];

  function nhanKieuNguoi(r) {
    var i;
    if (r.heartState === 'OVERLOADED') i = 0;
    else if (r.axes.ground  < 4) i = 1;
    else if (r.axes.voice   < 4) i = 2;
    else if (r.axes.meaning < 4) i = 3;
    else if (r.index >= 7.5) i = 4;
    else if (r.index >= 6)   i = 5;
    else i = 6;
    return isVI() ? NHAN[i][1] : NHAN[i][0];
  }

  /* ══════════════════════════════════════════════════════════════════════════
     8 · MỤC 3.4 · LỜI NHẬN XÉT — khung 4 mảnh có điều kiện

     Ghép ĐÚNG NGUYÊN VĂN, nối bằng một dấu cách, chỉ thay biến. Ba ví dụ ghép sẵn ở mục
     3.5 là bộ kiểm: kết quả phải khớp từng chữ. Dấu nháy đơn trong tài liệu là ’ (U+2019),
     không phải ' — chép sai một ký tự là lệch bộ kiểm.
     Lộ: vùng yếu nhất, tháng sắp tới. Giấu: TÊN vùng thứ hai (edge2), tháng đó xảy ra gì,
     việc 90 giây là gì.
     ══════════════════════════════════════════════════════════════════════════ */
  function loiNhanXet(r, han) {
    var vung = tierName(r.edge), m = [];

    /* mảnh 1 · mở đầu theo dải tổng điểm */
    if (r.index < 4) {
      m.push(L('Most of your 7 areas are already running low. This isn’t tiredness, it’s a leak, and it started earlier than you think.',
               'Phần lớn 7 vùng của bạn đã cạn. Đây không phải mệt, đây là rò, và nó bắt đầu sớm hơn bạn nghĩ.'));
    } else if (r.index < 7) {
      m.push(L('Most of your 7 areas are still holding, but one is already leaking, and you can’t feel it yet.',
               'Phần lớn 7 vùng của bạn vẫn giữ được, nhưng một vùng đã rò, và bạn chưa cảm thấy.'));
    } else {
      m.push(L('Your 7 areas look strong, which is exactly what makes the weak one dangerous: nobody is watching it, not even you.',
               '7 vùng của bạn trông khoẻ, và chính điều đó làm vùng yếu trở nên nguy hiểm: không ai để mắt tới nó, kể cả bạn.'));
    }

    /* mảnh 2 · vùng yếu nhất + úp mở vùng thứ hai (KHÔNG hiện tên edge2) */
    if (r.index < 7) {
      m.push(L('It’s ' + vung + '. And it isn’t leaking alone: there’s a second area already going with it. Your report names it.',
               'Đó là ' + vung + '. Và nó không rò một mình: có một vùng thứ hai đang đi theo. Báo cáo gọi tên vùng đó.'));
    } else {
      m.push(L('It’s ' + vung + ', the first to crack when a heavy month hits. And when it cracks, it takes one more area with it. Your report names which.',
               'Đó là ' + vung + ', vùng nứt đầu tiên khi một tháng nặng ập tới. Và khi nó nứt, nó kéo theo một vùng nữa. Báo cáo cho biết vùng nào.'));
    }

    /* mảnh 3 · tương lai sát nhất */
    if (han) {
      var thang = chuThang(han), tuan = soTuan(han);
      if (tuan >= 1 && tuan <= 8) {
        /* "1 weeks from now" — khuôn của tài liệu là "{Weeks} weeks", và {Weeks} = 1 xảy ra
           thật (thẻ tháng sau, hôm nay đã cuối tháng). Chia số ít cho bản EN; bản VI không
           có số nhiều nên giữ nguyên "còn {Tuần} tuần". */
        var dvi = (tuan === 1) ? ' week' : ' weeks';
        m.push(L('The next month that hits it is ' + thang + ', ' + tuan + dvi + ' from now. Your map already shows what that month brings to your door. It’s not what you’re bracing for.',
                 'Tháng gần nhất đánh vào vùng đó là ' + thang + ', còn ' + tuan + ' tuần. Bản đồ đã chỉ tháng đó mang gì tới cửa nhà bạn. Không phải thứ bạn đang đề phòng.'));
      } else {
        m.push(L('The next month that hits it is ' + thang + '. Your map already shows what that month brings, and the one thing to have ready before it.',
                 'Tháng gần nhất đánh vào vùng đó là ' + thang + '. Bản đồ đã chỉ tháng đó mang gì tới, và một thứ cần chuẩn bị sẵn trước đó.'));
      }
    } else if (!boQuaNgaySinh()) {
      /* HAI nhóm khách rơi vào nhánh không có `han`, và họ KHÁC nhau:

         · có ngày sinh nhưng máy chủ không đánh dấu tháng nào trong cửa sổ ba tháng — đây
           là nhánh THƯỜNG GẶP chứ không phải nhánh hiếm (C12), và cũng là nơi mọi lượt hỏi
           tháng hỏng rơi vào. Khách này CÓ bản đồ, 12 thẻ tháng và dòng thời gian, nên báo
           cáo vẫn nói được "còn bao lâu". Câu dưới đây giữ nguyên văn cho họ.
         · bấm Skip ngày sinh — `theHan()` trả null ngay ở dòng đầu. Khách này không có
           mốc thời gian nào để báo cáo dựa vào, nên mảnh 3 BỎ HẲN, không viết câu thay thế:
           mảnh 2 ngay trên đã nói phần còn giữ được ("có một vùng thứ hai đang đi theo.
           Báo cáo gọi tên vùng đó"), phần không giữ được chỉ là giờ giấc. Bỏ một mảnh
           không mất thông tin nào thật, và không phải nghĩ thêm lời hứa mới. */
      m.push(L('Your report shows how long you have before the second area follows, and it’s shorter than you think.',
               'Báo cáo chỉ bạn còn bao lâu trước khi vùng thứ hai đi theo, và ngắn hơn bạn nghĩ.'));
    }

    /* mảnh 4 · bước đầu — luôn có */
    m.push(L('There is one 90-second thing to do tonight that stops the leak from spreading. It’s the first page of your plan. Get the report and the plan to see it.',
             'Có một việc 90 giây để làm tối nay, chặn chỗ rò không lan. Nó nằm ở trang đầu kế hoạch của bạn. Nhận báo cáo và kế hoạch để xem.'));

    return m.join(' ');
  }

  /* ══════════════════════════════════════════════════════════════════════════
     9 · MỤC 3.7 · KHỐI LỢI ÍCH + GIÁ — HAI GÓI $4.90 / $19

     `map:true` = dòng thuộc BẢN ĐỒ. Từ 08/09/2026 KHÔNG lọc theo Skip nữa: khách bỏ qua
     ngày sinh vẫn mua trọn gói và điền ngày sinh sau thanh toán (`POST /api/quiz/birth`,
     form ngay trên trang đọc `pheu-luan-giai`), nên bốn dòng này là lời hứa giao sau, không phải hứa hão.
     Dòng `offMapSau` ngay trên nút mua nói đúng điều đó.
     ══════════════════════════════════════════════════════════════════════════ */
  var LOI_ICH = [
    { map: true,  en: 'You see **the real sky the day you were born**: 10 planets, computed, not guessed',
                  vi: 'Bạn thấy **bầu trời thật ngày bạn sinh**: 10 hành tinh, tính thật, không đoán' },
    { map: true,  en: 'You get your **12 month-cards for 2026–2027**: the months that hit hardest, each with do this / don’t do that',
                  vi: '**12 thẻ tháng cho 2026–2027**: những tháng chạm mạnh nhất, mỗi tháng có nên làm / đừng làm' },
    { map: true,  en: 'You read **your next 10 years**, year by year, 2026 to 2035: what’s coming and what it means for you',
                  vi: 'Bạn đọc **10 năm tới**, từng năm, 2026 đến 2035: có gì và nghĩa gì với bạn' },
    { map: true,  en: 'You get **6 things you’re already living through**, and the month each one comes back',
                  vi: '**6 chuyện bạn đang gặp**, và tháng nó quay lại' },
    { map: false, en: 'You get **all 7 areas scored**, the weakest named, and why it went first',
                  vi: '**7 vùng có điểm**, vùng yếu nhất được gọi tên, và vì sao nó yếu trước' },
    { map: false, en: 'You get your **first 90-second ritual**, open tonight',
                  vi: '**Nghi thức 90 giây đầu tiên**, mở ngay tối nay' },
    /* Chữ gốc nói "hợp bản đồ của bạn"; lúc khách Skip đọc câu này thì chưa có bản đồ,
       nên bản Skip neo vào 7 vùng — thứ khách đó có ngay. */
    { map: false, en: 'You see **your 5-step solution path**, in the order that fits your map',
                  vi: '**Lộ trình giải pháp 5 bước**, theo thứ tự hợp bản đồ của bạn',
                  enSkip: 'You see **your 5-step solution path**, in the order that fits your 7 areas',
                  viSkip: '**Lộ trình giải pháp 5 bước**, theo thứ tự hợp 7 vùng của bạn' }
  ];

  /* ── 5 Giải pháp · chỉ thuộc gói $19 ───────────────────────────────────────
     Chép nguyên văn tài liệu 07/09/2026 trang 10-11, cột tiếng Anh và tiếng Việt.

     `map: true` ở dòng 5 vì nó đọc từ Bản đồ mục 8 (`renderFourLegs(chart)` bên API):
     không có ngày sinh thì không có nút thắt nào để in. Bốn dòng còn lại render từ copy
     tĩnh (`renderDoors()` không nhận tham số nào), nên khách bỏ qua ngày sinh vẫn nhận đủ.
     Chữ của dòng 1 và 2 còn nói "written from your map" — marketing đang viết lại bản
     không cần lá số, thay vào đây khi có. */
  var GIAI_PHAP = [
    { map: false, en: '**Where to untangle first**, written from your map: the first knot, the sentence to say, the boundary to reset',
                  vi: '**Chỗ cần gỡ trước**, viết theo bản đồ của bạn: nút thắt đầu tiên, câu cần nói, ranh giới cần đặt lại' },
    { map: false, en: 'Your **daily practice rhythm**, written for your map, one touchpoint a day: a line for your area, a small ritual, one question to write, one action under 5 minutes',
                  vi: '**Nhịp thực hành hằng ngày** viết theo bản đồ của bạn, mỗi ngày một điểm chạm: một câu nhắc đúng vùng, một nghi thức nhỏ, một câu hỏi để viết, một hành động dưới 5 phút' },
    { map: false, en: 'Your **kit recommendation**, read from your weakest area: which 4 objects fit that area and why, so you know exactly what to keep near you',
                  vi: '**Gợi ý bộ vật neo** đọc từ vùng yếu nhất: 4 món nào hợp vùng đó và vì sao, để bạn biết chính xác nên giữ gì bên mình' },
    { map: false, en: 'Your **7-day map**: one area a day, one action under 5 minutes, one sign you are getting better',
                  vi: '**Bản đồ 7 ngày**: mỗi ngày một vùng, một việc dưới 5 phút, một dấu hiệu khá hơn' },
    /* `map: false` từ 08/09/2026. Dòng này đọc Bản đồ mục 8, nhưng khách bỏ qua ngày sinh
       nay điền bù được sau khi mua (`POST /api/quiz/birth`, form ngay trên trang đọc),
       nên nó KHÔNG còn là lời hứa không giao được — chỉ là lời hứa giao sau. Dòng nhắc
       ngay dưới danh sách nói đúng điều đó. */
    { map: false, en: 'Your **today → target chart**: where each of your 4 groups stands now, and the target for the thinnest one',
                  vi: '**Bảng hôm nay → mục tiêu**: 4 nhóm của bạn đang ở đâu, và mốc cần tới cho nhóm mỏng nhất' }
  ];

  /* Hai gói. `ma` đi vào sự kiện đo, `gia` là chuỗi gửi kèm — cả hai phải khớp với con số
     in trên màn, nếu không thì báo cáo doanh thu và màn bán nói hai chuyện khác nhau. */
  var GOI_THAP = { ma: 'map_report_490',    gia: '4.90', khoa: 'offPrice'  };
  var GOI_CAO  = { ma: 'map_report_5sol_19', gia: '19.00', khoa: 'offPrice2' };

  /* Mã biến thể gói cao do `quiz-sang-trang-ban.js` đọc từ Liquid. Rỗng = chưa cấu hình →
     giữ nguyên màn một gói như trước, KHÔNG bày lựa chọn không mua được. */
  function coGoiCao() {
    return typeof window.__msVariantCao === 'string' && window.__msVariantCao !== '';
  }

  /* Gói đang chọn. Mặc định là gói cao — tài liệu trang 12 ghi gói 2 `●` (chọn sẵn). */
  var goiDangChon = GOI_CAO;

  /* ══════════════════════════════════════════════════════════════════════════
     10 · MÀN KẾT QUẢ (thay hub + docMap + docReport + sale4)

     Giữ khoá màn `hub`: `IDX_RESULT`, `?demo=`, và `quiz-goi-api.js` (danh sách
     `MAN_KET_QUA`) đều bám tên đó. Đổi tên màn là phải sửa ba nơi cho không được gì.
     ══════════════════════════════════════════════════════════════════════════ */
  function oSo(nhan, giaTri) {
    return '<div class="gd1-box"><span class="gd1-boxlab">' + esc(nhan) + '</span>' +
           '<span class="gd1-boxval">' + esc(giaTri) + '</span></div>';
  }

  /* Ô vùng yếu nhất: bản nổi bật (yêu cầu marketing 09/09/2026). Con số điểm tách ra một
     dòng riêng, to và đỏ cảnh báo — cùng màu đồng hồ 9:59 — để khách thấy ngay mình
     đang có vấn đề; tên vùng giữ cỡ chữ cũ. */
  function oYeu(nhan, ten, diem) {
    return '<div class="gd1-box gd1-box--yeu"><span class="gd1-boxlab">' + esc(nhan) + '</span>' +
           '<span class="gd1-boxval">' + esc(ten) + '</span>' +
           '<span class="gd1-diem">' + esc(String(diem)) + '<small>/100</small></span></div>';
  }

  /* A6 (phase 24) viết lại HẲN màn kết quả trong `quiz-bo-de-dung-man.js` rồi cắm cờ
     `__msMan24`. Cùng khuôn với `__msMan19` và `__msMan23`: file này nạp ở thẻ #6, SAU
     overlay, nên gán tiếp là ném bản v7.9 đi trong im lặng. Không xoá hàm dưới — snapshot
     vắng thì overlay thoát sớm và đây là màn kết quả duy nhất còn lại. */
  if (!window.__msMan24) {
  RENDER.hub = function () {
    chotTen();
    var r = res7();
    var han = theHan();
    /* Ô 1 in ĐIỂM CỦA VÙNG (`axes[edge]`), KHÔNG phải giá trị đua.
       Với tim hai thứ đó KHÁC NHAU: `axes.heart` = mid = (give+receive)/2 để dùng cho chỉ
       số tổng · biên độ · báo cáo 7 vùng, còn giá trị đua tìm vùng yếu nhất là
       min(give, receive) — xem khối `timVaoCuoc` ở trên, và cả server (`rankAxisVals_`)
       cũng tách hai thuộc đo như vậy.

       CON SỐ GIỮ NGUYÊN LÀ mid, NHÃN MỚI LÀ THỨ ĐỔI. Đổi số sang giá trị đua thì ô này
       lệch khỏi báo cáo 7 vùng mà khách trả tiền để đọc — server dựng báo cáo đó bằng
       `axes[edge]` ở cả ba đường (`report7-copy.js`, `v9-render-copy.js`, `tokens.ts`).
       Nên chỗ sai là CHỮ, không phải SỐ: 'Weakest area' khẳng định đây là con số thấp
       nhất, mà với tim thì không — đo 08/09 hồ sơ give 10 / nhận 2,5 ra 63/100 trong khi
       sáu vùng còn lại ở 50/100. Nhãn tim nói đúng thứ ô này thật sự chỉ: chỗ đang rò. */
    var diem = Math.round((r.axes[r.edge] || 0) * 10);
    var nhanO1 = r.edge === 'heart' ? G('resBox1Tim') : G('resBox1');
    var locks = GS('resLocks');

    var box2 = state.bdate && han
      ? oSo(G('resBox2a'), chuThang(han))
      : oSo(G('resBox2b'), G('resTonight'));

    var html = topbar() +
      '<div class="mid gd1-res">' +
        '<div class="kicker">' + esc(G('resKick')) + '</div>' +
        '<h1 class="big gd1-nhan">' + esc(nhanKieuNguoi(r)) + '</h1>' +
        '<div class="gd1-boxes">' +
          oYeu(nhanO1, tierName(r.edge), diem) +
          box2 +
        '</div>' +
        '<p class="sub gd1-nx">' + esc(loiNhanXet(r, han)) + '</p>' +
        '<ul class="gd1-locks">' +
          locks.map(function (x) { return '<li>🔒 ' + esc(x) + '</li>'; }).join('') +
        '</ul>' +
      '</div>' +
      /* PHẢI giữ lớp `.foot` ở đây, dù màn này không muốn một thanh dính đáy.
         `dockLone()` (`quiz-inner-weather.js:28583`) tự DỜI nút `.btn` CUỐI CÙNG trong `#scr`
         vào một thanh dính `.v3foot` khi màn cao hơn 1,5 màn hình VÀ trong `#scr` không có
         `.stickybar` / `.foot` / `.v3foot` nào. Không có `.foot` thì nút cuối là `#gd1-buy` —
         nút MUA đang nằm trong khối `hidden` — và nó bị lôi ra ngoài, hiện ngay từ lúc khách
         vừa xem kết quả, trước cả khi bấm nút mở khối chào hàng. Đo 08/09: `#gd1-buy` có
         `parentElement.className === 'v3foot'`.
         Phần dính đáy của `.foot` được gỡ ở `quiz-giai-doan-1.css`. */
      '<div class="foot gd1-resfoot">' +
        '<button class="btn" id="gd1-cta">' + esc(GS('resBtn')) + '</button>' +
        '<p class="tiny">' + esc(GS('resUnder')) + '</p>' +
      '</div>';

    return { html: html, bind: function () { ganKetQua(r); } };
  };
  }  /* hết cổng `__msMan24` */

  /* ── Màn chào hàng riêng (`gd1off`, đứng ngay sau `hub`) ───────────────────
     Từ 09/09/2026 khối lợi ích + giá không còn trượt xuống trên cùng màn kết quả: bấm nút
     ở màn kết quả là sang màn này. Nút quay lại của `topbar()` đưa về màn kết quả.

     A7 (phase 25) viết lại HẲN màn giá trong `quiz-bo-de-dung-man.js` rồi cắm cờ
     `__msMan25`. Cùng khuôn với `__msMan19` · `__msMan23` · `__msMan24`: file này nạp ở
     thẻ #6, SAU overlay đó, nên gán tiếp là ném bản v7.9 đi trong im lặng. Bản dưới đây
     (hai gói, đồng hồ 9:59) vẫn phải còn: overlay thoát sớm khi snapshot vắng hoặc sai
     dạng, và khi đó không có cờ nào được cắm. */
  if (!window.__msMan25) {
  RENDER.gd1off = function () {
    chotTen();
    return {
      html: topbar() + '<div class="mid gd1-res">' + khoiChaoHang() + '</div>',
      bind: ganChaoHang
    };
  };
  }  /* hết cổng `__msMan25` */

  /* ── Khối lợi ích + giá · thân của màn `gd1off` ─────────────────────────────
     Nút mua nằm trong `.foot` để dính đáy như các màn khác của quiz; không có `.foot` thì
     `dockLone()` tự lôi nút cuối vào `.v3foot`, ra ngoài `.gd1-off` và mất màu xanh. */
  /* Dòng giá là MỘT câu do marketing giữ ("TÊN GÓI · $giá · điều kiện · …"), không cắt
     thành nhiều khoá được. Ở đây chỉ TÁCH nó ra ba phần theo dấu " · " để dựng bố cục —
     tên gói nhỏ phía trên, con số tiền to bên phải, điều kiện nhỏ phía dưới — chữ không
     đổi một từ. Escape TRƯỚC rồi mới chèn thẻ. Không tìm thấy phần có `$` thì trả nguyên
     câu, đừng dựng khung rỗng.
     `G`, KHÔNG `GS`: tên gói không có bản Skip, `GS` sẽ đi tìm `offPrice2Skip` — khoá
     không tồn tại, và `G` nổ ngay ở `v[0]`. */
  function chuGia(khoa) {
    var cau = G(khoa), phan = cau.split(' · '), iGia = -1, i;
    for (i = 0; i < phan.length; i++) if (/\$\d/.test(phan[i])) { iGia = i; break; }
    if (iGia < 1) return esc(cau);
    var con = phan.slice(iGia + 1).join(', ');
    return '<span class="gd1-goiten">' + esc(phan.slice(0, iGia).join(' · ')) + '</span>' +
           '<span class="gd1-price-amt">' + esc(phan[iGia]) + '</span>' +
           (con ? '<span class="gd1-goimeta">' + esc(con) + '</span>' : '');
  }

  function mot(goi, chon) {
    return '<label class="gd1-goi1' + (chon ? ' chon' : '') + '">' +
      '<input type="radio" name="gd1-goi" value="' + esc(goi.ma) + '"' +
        (chon ? ' checked' : '') + '>' +
      '<span class="gd1-goichu">' + chuGia(goi.khoa) + '</span>' +
    '</label>';
  }

  function khoiChaoHang() {
    var bo = boQuaNgaySinh();
    var ds = LOI_ICH;
    var gp = GIAI_PHAP;
    var hai = coGoiCao();

    /* Một gói thì không có gì để chọn — giữ nguyên dòng giá phẳng như trước 08/09/2026. */
    var khoiGia = hai
      ? '<div class="gd1-goi" id="gd1-goi">' + mot(GOI_THAP, false) + mot(GOI_CAO, true) + '</div>'
      : '<div class="gd1-price">' + chuGia(GOI_THAP.khoa) + '</div>';

    /* Năm dòng Giải pháp dựng sẵn nhưng ẩn theo gói đang chọn, không chèn/xoá lúc đổi:
       chèn lại làm khối nhảy chiều cao ngay dưới ngón tay khách vừa bấm. */
    var khoiGP = (hai && gp.length)
      ? '<ul class="gd1-ben gd1-sol" id="gd1-sol">' +
          '<li>' + dam(G('offGoi2Dau')) + '</li>' +
          gp.map(function (x) { return '<li>' + dam(isVI() ? x.vi : x.en) + '</li>'; }).join('') +
        '</ul>'
      : '';

    return '<div class="gd1-off" id="gd1-off">' +
      '<div class="gd1-offin">' +
        '<h2 class="gd1-offtitle">' + esc(GS('offTitle').replace('{Name}', state.name)) + '</h2>' +
        '<div class="gd1-cd"><span class="gd1-cdnum" id="gd1-cdnum">9:59</span>' +
          '<span class="gd1-cdlab">' + esc(G('offHold')) + '</span></div>' +
        '<ul class="gd1-ben">' +
          ds.map(function (x) {
            var en = (bo && x.enSkip) || x.en, vi = (bo && x.viSkip) || x.vi;
            return '<li>' + dam(isVI() ? vi : en) + '</li>';
          }).join('') +
        '</ul>' +
        khoiGP +
        khoiGia +
        nhacBanDo() +
      '</div>' +
      '<div class="foot">' +
        '<button class="btn gd1-mua" id="gd1-buy">' + esc(G('offBtn')) + '</button>' +
        '<p class="tiny">' + esc(G('offUnder')) + '</p>' +
      '</div>' +
    '</div>';
  }

  /* Dòng nhắc "Bản đồ cần ngày sinh, thêm sau cũng được". Dựng khi khách bấm Skip, không
     phụ thuộc gói: cả $4.90 lẫn $19 đều có phần Bản đồ. */
  function nhacBanDo() {
    if (!boQuaNgaySinh()) return '';
    return '<p class="tiny gd1-mapsau" id="gd1-mapsau">' + esc(G('offMapSau')) + '</p>';
  }

  /* Bật/tắt 5 dòng Giải pháp theo gói đang chọn. Gọi cả lúc mở khối lần đầu để trạng thái
     ban đầu khớp với gói được chọn sẵn, thay vì tin vào thứ tự dựng HTML. */
  function hienGiaiPhap() {
    var o = $('gd1-sol');
    var hop = document.getElementById('gd1-goi');
    /* Bù cuộn: 6 dòng Giải pháp nằm TRÊN hai ô gói, nên bật/tắt chúng là đẩy ô gói và nút
       mua trượt khỏi chỗ ngón tay vừa bấm. Đo vị trí ô gói trước và sau, rồi cộng phần lệch
       vào khung cuộn `#scr` — ô gói đứng yên, nội dung phía trên dài ra và trôi lên. */
    var sc = document.getElementById('scr');
    var truoc = hop && sc ? hop.getBoundingClientRect().top : null;
    if (o) o.hidden = goiDangChon !== GOI_CAO;
    if (truoc !== null) {
      var lech = hop.getBoundingClientRect().top - truoc;
      if (lech) sc.scrollTop += lech;
    }
    if (!hop) return;
    var nhan = hop.querySelectorAll('.gd1-goi1');
    for (var i = 0; i < nhan.length; i++) {
      var r = nhan[i].querySelector('input');
      nhan[i].className = 'gd1-goi1' + (r && r.checked ? ' chon' : '');
    }
  }

  /* ── Đồng hồ 9:59 (mục 3.7 · đã chốt GIỮ) ──────────────────────────────────
     Hẹn giờ đẩy vào `timers` của quiz để `clearTimers()` dọn khi chuyển màn — bỏ ngoài đó
     là mỗi lần vẽ lại màn kết quả đẻ thêm một interval chạy song song. */
  function chayDongHo() {
    var o = $('gd1-cdnum');
    if (!o) return;
    var con = 599;
    o.textContent = '9:59';
    timers.push(setInterval(function () {
      if (con <= 0) return;
      con--;
      var p = Math.floor(con / 60), g = con % 60;
      o.textContent = p + ':' + (g < 10 ? '0' : '') + g;
    }, 1000));
  }

  /* ── Đi tới thanh toán ─────────────────────────────────────────────────────
     Dùng lại đúng đường `quiz-sang-trang-ban.js` đang chạy (`/cart/add.js` → gắn mã phiên
     → `/checkout`, lui về `data-dich-ban` khi hỏng). KHÔNG chép lại: đường đó mang mã phiên
     ở CẢ thuộc tính cấp đơn lẫn dòng hàng, và cả hai đều đã trả giá để tìm ra. */
  function diThanhToan(nut) {
    /* Gói cao đi bằng mã biến thể riêng; gói thấp truyền chuỗi rỗng để `muaNgay()` dùng
       mã mặc định của nó — đừng đoán mã gói thấp ở đây, một bản sao là một chỗ để lệch. */
    var ma = goiDangChon === GOI_CAO ? (window.__msVariantCao || '') : '';
    if (typeof window.__msMuaNgay === 'function') { window.__msMuaNgay(nut, ma); return; }
    if (typeof window.__msSangTrangBan === 'function') { window.__msSangTrangBan(); return; }
    /* Chưa khai `data-variant-goi` lẫn `data-dich-ban` — không có đích nào để đi.
       Đừng bỏ khách ở nút chết: mở lại nút để họ bấm lần nữa sau khi cấu hình xong. */
    if (nut) { nut.disabled = false; nut.removeAttribute('aria-busy'); }
  }

  /* ══════════════════════════════════════════════════════════════════════════
     Trình diễn màn kết quả: chữ gõ dần → ba dòng khoá → nút

     Đổ hết một lượt thì khách đọc thứ tự ngược: mắt bắt ngay ba ổ khoá và cái nút,
     nhận ra đây là trang bán trước cả khi kịp đọc mình yếu vùng nào. Cho từng lớp
     hiện theo nhịp thì câu nhận xét được đọc trước, ổ khoá đến sau để nói còn gì
     chưa mở, cái nút đến cuối cùng — đúng thứ tự một lời chào hàng tử tế.

     Bốn thứ phải đúng, nếu không hiệu ứng thành phiền:

     · MẶC ĐỊNH TRONG CSS LÀ HIỆN. Lớp `.gd1-an` do JS gắn vào lúc chạy, không viết
       sẵn trong markup. Nếu JS hỏng giữa chừng thì khách vẫn thấy nút mua — chứ
       không phải một cái nút vô hình không bấm được. Ẩn sẵn trong CSS là đánh cược
       đường bán hàng vào việc JS không bao giờ lỗi.
     · CHỈ ĐỘNG `opacity`/`transform`, KHÔNG ĐỘNG `display`. Ba dòng khoá và chân
       trang vẫn chiếm đủ chỗ suốt lúc ẩn, nên không có gì xê dịch khi chúng hiện ra.
       Cộng với `minHeight` khoá cho đoạn chữ, cả màn đứng yên từ đầu tới cuối.
     · KHÔNG CHO BỎ QUA. Trước 09/09/2026 chạm/cuộn/gõ phím là hiện thẳng toàn bộ, với
       lý do "người đã chạm là người đang vội". Bỏ đi: màn này LÀ phần giá trị khách
       vừa trả tiền để nhận, chữ hiện dần là cách trao nó — cho bỏ qua là tự hạ giá
       trị sản phẩm, và một cú chạm nhầm hay một nhịp cuộn cũng giết mất màn diễn.
       Người thật sự không muốn xem hiệu ứng đã có `prefers-reduced-motion` lo.
     · TỔNG THỜI GIAN GÕ CỐ ĐỊNH, không phải ms mỗi ký tự. Câu nhận xét dài ngắn tuỳ
       hồ sơ (đo thật: 350–504 ký tự); khoá theo ms/ký tự thì hồ sơ dài phải ngồi chờ
       lâu hơn hồ sơ ngắn mà chẳng vì lý do gì.

     `prefers-reduced-motion` thì hiện thẳng cả màn, không gõ và không diễn — người
     bật cờ đó đã nói rõ họ muốn gì. Mọi hẹn giờ đẩy vào `timers` để `clearTimers()`
     dọn khi chuyển màn, cùng kỷ luật với `chayDongHo()`. ────────────────────────── */
  var CHU_TONG_MS = 10000;
  var CHU_MIN_MS = 18, CHU_MAX_MS = 66;
  /* Nhịp hiện, tính từ lúc chữ gõ xong. Thưa hơn thời gian chuyển (.45s trong CSS)
     để mắt kịp bắt từng dòng, thay vì thấy cả cụm nhoè lên cùng lúc. */
  var KHOA_DAU_MS = 120, KHOA_NHIP_MS = 200, CHAN_THEM_MS = 160;

  function itDong() {
    try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
    catch (e) { return false; }
  }

  /* Ẩn ĐÚNG phần tử mang chữ, không ẩn cái bọc ngoài. Bản port có một lưới an toàn
     tương phản (`quiz-inner-weather.js:28696`) chạy sau mỗi lần vẽ: gặp phần tử có chữ
     mà một tổ tiên đang mờ thì nó ép `opacity:1!important` INLINE lên cả chuỗi tổ tiên
     đó. Ẩn `.gd1-resfoot` là rơi đúng bẫy — đo được `style="opacity: 1 !important"` trên
     chân trang, nút hiện ngay từ đầu. Nhưng chính lưới đó lại tha phần tử NÀO TỰ nó
     `opacity:0`, coi là "ẩn có chủ ý" (:28701). Nên ẩn thẳng cái nút và dòng chữ nhỏ. */
  function chanKetQua() {
    var chan = document.querySelector('.gd1-resfoot');
    if (!chan) return [];
    return [].slice.call(chan.querySelectorAll('.btn, .tiny'));
  }

  function trinhDien() {
    var o = document.querySelector('.gd1-nx');
    var khoa = [].slice.call(document.querySelectorAll('.gd1-locks li'));
    var chan = chanKetQua();
    var lop = khoa.concat(chan);

    if (!o || itDong() || !lop.length) return;

    var full = o.textContent;
    if (!full) return;

    o.style.minHeight = o.getBoundingClientRect().height + 'px';
    lop.forEach(function (e) { e.classList.add('gd1-an'); });

    var buoc = Math.round(CHU_TONG_MS / full.length);
    if (buoc < CHU_MIN_MS) buoc = CHU_MIN_MS;
    if (buoc > CHU_MAX_MS) buoc = CHU_MAX_MS;

    var i = 0, id = null, xong = false;
    o.textContent = '';
    o.classList.add('gd1-go');

    function hienLop() {
      khoa.forEach(function (e, k) {
        timers.push(setTimeout(function () { e.classList.remove('gd1-an'); },
                               KHOA_DAU_MS + k * KHOA_NHIP_MS));
      });
      /* Nút và dòng bảo đảm dưới nó hiện CÙNG lúc: chúng là một cụm, tách ra thì cái
         nút đứng trơ một nhịp rồi mới có chữ trấn an bên dưới. */
      var treChan = KHOA_DAU_MS + khoa.length * KHOA_NHIP_MS + CHAN_THEM_MS;
      chan.forEach(function (e) {
        timers.push(setTimeout(function () { e.classList.remove('gd1-an'); }, treChan));
      });
    }

    function ketThuc() {
      if (xong) return;
      xong = true;
      if (id) clearInterval(id);
      o.textContent = full;
      o.classList.remove('gd1-go');
      o.style.minHeight = '';
      hienLop();
    }

    id = setInterval(function () {
      if (xong) return;
      i++;
      if (i >= full.length) { ketThuc(); return; }
      o.textContent = full.slice(0, i);
    }, buoc);
    timers.push(id);
  }

  function ganKetQua(r) {
    suKien('result_view', {
      screen: 'hub',
      edge: r.edge || '',
      edge_score: Math.round((r.axes[r.edge] || 0) * 10),
      band: (r.band && r.band.key) || '',
      has_birthdate: !!state.bdate
    });

    trinhDien();

    var cta = $('gd1-cta');
    if (!cta) return;
    cta.onclick = function () {
      sfx('tap');
      suKien('cta_click', { screen: 'hub' });
      goto(cur + 1);
    };
  }

  /* Tên màn trong sự kiện giữ là 'hub' cho offer_view · plan_select · checkout_start: báo
     cáo phễu đang lọc theo tên đó, tách màn không đổi hợp đồng đo. */
  function ganChaoHang() {
    var off = $('gd1-off'), buy = $('gd1-buy');
    if (!off) return;

    /* Gói cao chưa cấu hình mã biến thể → chỉ có gói thấp trên màn, và đó cũng là gói
       khách sẽ mua. Chốt lại ở đây thay vì tin vào giá trị mặc định lúc nạp file. */
    if (!coGoiCao()) goiDangChon = GOI_THAP;

    var hop = document.getElementById('gd1-goi');
    if (hop) {
      hop.addEventListener('change', function (e) {
        var o = e.target;
        if (!o || o.name !== 'gd1-goi') return;
        var moi = o.value === GOI_CAO.ma ? GOI_CAO : GOI_THAP;
        if (moi === goiDangChon) return;
        goiDangChon = moi;
        hienGiaiPhap();
        sfx('tap');
        /* Bắn LẠI mỗi lần đổi gói. Đây là thứ `plan_select` đo: gói khách chốt, không phải
           gói được bày ra. Lần bắn cuối trước `checkout_start` mới là lựa chọn thật. */
        suKien('plan_select', { screen: 'hub', plan: goiDangChon.ma, price: goiDangChon.gia });
        /* Giỏ dựng sẵn đang mang gói CŨ. Dựng lại cho gói mới — nếu không, lúc bấm chữ ký
           lệch và khách rơi về đường chậm, tức mất đúng phần vừa làm ra. */
        dungSanGio();
      });
    }

    hienGiaiPhap();
    chayDongHo();
    suKien('offer_view', { screen: 'hub' });
    /* Lần bắn đầu: gói đang được chọn sẵn. Khách không đụng gì rồi bấm mua thì đây
       chính là gói họ mua, nên nó phải có mặt trong chuỗi sự kiện. */
    suKien('plan_select', { screen: 'hub', plan: goiDangChon.ma, price: goiDangChon.gia });

    if (buy) {
      buy.onclick = function () {
        sfx('tap');
        suKien('checkout_start', { screen: 'hub', plan: goiDangChon.ma, price: goiDangChon.gia });
        diThanhToan(buy);
      };
    }

    /* Dựng sẵn giỏ NGAY khi khối chào hàng hiện, đừng đợi khách bấm. Đo live 15/09/2026:
       riêng `cartCreate` tốn 0,87–1,08 giây, cộng phần đợi mã phiên thì cú bấm mất tới
       5,1 giây mới sang được checkout. Cả hai việc đó không cần đứng sau cú bấm. */
    dungSanGio();
  }

  /* Bọc `window.__msDungSanGio` để chỗ gọi khỏi phải nhớ kiểm tra. Chưa khai mã biến thể thì
     bên kia phơi `null` — im lặng bỏ qua, đúng như `diThanhToan()` vẫn làm. */
  function dungSanGio() {
    if (typeof window.__msDungSanGio !== 'function') return;
    var ma = goiDangChon === GOI_CAO ? (window.__msVariantCao || '') : '';
    try { window.__msDungSanGio(ma); } catch (e) {}
  }

  /* ══════════════════════════════════════════════════════════════════════════
     11 · MỤC 2 + 3.8 · DỰNG LẠI THỨ TỰ MÀN

     Chuỗi mới sau 3 câu chọn nhiều:
       Credibility → Expert → Social → Ngày sinh → Tên → Email → Tính kết quả → Kết quả
     BỎ: giờ sinh (btime), nơi sinh (bplace), xưng hô (pick7:gender), và ba màn đọc miễn
     phí docMap · docReport · sale4 (mục 3.8).
     GIỮ NGUYÊN phần sau thanh toán: payment · delivery · mapFull · reportFull · signup · done.

     Giữ NGUYÊN OBJECT màn cũ chứ không dựng object mới: một số màn mang thuộc tính riêng
     (`src`, `mi`, `ii`) mà renderer đọc tới.
     Cắt theo TÊN màn, không theo chỉ số: thứ tự đã đổi bốn lần trong hai tuần.
     ══════════════════════════════════════════════════════════════════════════ */
  var DUOI = ['credibility', 'expert', 'social', 'bdate', 'name', 'email', 'calc', 'hub',
              'payment', 'delivery', 'mapFull', 'reportFull', 'signup', 'done'];
  var THAN = { intro: 1, q7duo: 1, q7: 1, inter: 1, multi7: 1 };

  (function dungLaiManHinh() {
    /* A0 (phase 18) gom việc dựng `SCREENS` về MỘT chỗ: `quiz-bo-de-dung-man.js`.
       Overlay đó chạy ở thẻ #4, trước file này, và dựng đủ 38 màn của v7.9 rồi cắm cờ
       `__msManA0`. Đoạn cắt dưới đây là lớp dựng THỨ HAI; để nó chạy tiếp là nó xoá mất
       màn `reframe` (màn 2, THÊM MỚI) — `reframe` không nằm trong `THAN` cũng không nằm
       trong `DUOI`, và hai cổng thoát sẵn có không bắt được: tên thiếu thì vòng lặp
       không push gì nên `duoi.indexOf(undefined)` luôn `-1`, còn `coHub` chỉ sai khi bỏ
       hẳn `hub`. Đo 21/09 trên theme development: overlay dựng 38 → còn 37, mất đúng
       `reframe`.
       KHÔNG xoá hẳn đoạn này: khi snapshot vắng hoặc sai dạng thì overlay tự thoát sớm
       và không cắm cờ, lúc đó bundle chạy bản cũ và đoạn cắt này vẫn là lớp lọc cần có. */
    if (window.__msManA0) return;
    var than = [], i, s;
    for (i = 0; i < SCREENS.length; i++) {
      s = SCREENS[i];
      if (THAN[s.t]) than.push(s);
    }
    var duoi = [];
    for (i = 0; i < DUOI.length; i++) {
      for (var j = 0; j < SCREENS.length; j++) {
        if (SCREENS[j].t === DUOI[i]) { duoi.push(SCREENS[j]); break; }
      }
    }
    /* Không tìm thấy màn kết quả nghĩa là bundle đã đổi tên màn — dừng tay, để nguyên
       mảng cũ. Thà chạy bản cũ còn hơn cắt mất nửa phễu mà không lỗi nào báo. */
    if (duoi.indexOf(undefined) >= 0) return;
    var coHub = false;
    for (i = 0; i < duoi.length; i++) if (duoi[i].t === 'hub') coHub = true;
    if (!coHub) return;

    for (i = 0; i < duoi.length; i++) {
      if (duoi[i].t === 'hub') { duoi.splice(i + 1, 0, { t: 'gd1off' }); break; }
    }
    SCREENS.length = 0;
    Array.prototype.push.apply(SCREENS, than.concat(duoi));
    if (typeof idxOf === 'function') IDX_RESULT = idxOf('hub');
  })();

  /* ══════════════════════════════════════════════════════════════════════════
     12 · VẼ LẠI MÀN ĐANG HIỆN

     `boot()` chạy ở cuối `quiz-inner-weather.js`, tức TRƯỚC file này: màn đã dựng bằng
     `RENDER` cũ và `SCREENS` cũ, và `cur` đang trỏ vào chỉ số của mảng CŨ. Không vẽ lại
     thì khách thấy màn intro chữ cũ, còn `?demo=`/`?screen=` thì trỏ nhầm màn.
     Chép đúng khuôn dựng màn của `boot()` (:28496-28500) chứ không gọi `goto()`: `goto()`
     có 180ms fade và sẽ bắn thêm một `screen_viewed`.
     ══════════════════════════════════════════════════════════════════════════ */
  (function veLai() {
    var qs = {};
    location.search.replace(/^\?/, '').split('&').forEach(function (kv) {
      if (!kv) return;
      var p = kv.split('=');
      qs[decodeURIComponent(p[0])] = decodeURIComponent(p[1] || '');
    });

    var start = 0;
    if (qs.demo && typeof DEMO7 !== 'undefined' && DEMO7[qs.demo]) start = IDX_RESULT;
    if (qs.screen) {
      var n = parseInt(qs.screen, 10);
      if (n >= 1 && n <= SCREENS.length) start = n - 1;
    }
    /* `?demo=` gán `state.bplace`/`state.btime` cho hai màn đã bỏ — vô hại, lá số vẫn cần
       chúng. Nhưng xưng hô thì phải đặt lại: boot đã ghi đè bằng `src.GENDER || 0`. */
    datXungHo();

    try {
      cur = start;
      var s = SCREENS[cur];
      var built = RENDER[s.t](s);
      $('app').innerHTML = '<div class="screen" id="scr">' + built.html + '</div>';
      bindShell();
      if (built.bind) built.bind();
    } catch (e) {
      /* Vẽ hụt thì để nguyên màn `boot()` đã dựng — xấu chữ còn hơn trắng màn. */
    }
  })();
})();
